import { remoteConfig } from '../config/firebase';

export async function isUnderMaintenance() {
  try {
    await remoteConfig.fetchAndActivate();

    return remoteConfig.getBoolean(process.env.REACT_APP_FIREBASE_MAINTENANCE_FLAG);
  } catch (error) {
    return false;
  }
}
